import React from 'react'
import { ResponsivePie } from '@nivo/pie'
import { useWindowSize } from 'react-use'


const MyResponsivePie = (props) => {
    let src, content
    const { width } = useWindowSize()

    if (props?.object) {
        src = props.object.src
        content = props.object.content
    } else {
        content = props.content
    }

    return (
        <>
            <div style={{ height: 300 }}>
                <ResponsivePie
                    theme={{
                        fontFamily: "Open Sans"
                    }}
                    data={content}
                    margin={{ top: 40, right: 20, bottom: 80, left: 80 }}
                    innerRadius={0.5}
                    padAngle={0.7}
                    cornerRadius={3}
                    colors={{ scheme: 'nivo' }}
                    borderWidth={1}
                    borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
                    enableRadialLabels={false}
                    slicesLabelsSkipAngle={10}
                    slicesLabelsTextColor="#333333"
                    animate={true}
                    motionStiffness={90}
                    motionDamping={15}
                    legends={width < 768 ? [] : [
                        {
                            anchor: 'left',
                            direction: 'column',
                            itemWidth: 100,
                            itemHeight: 22,
                            itemTextColor: '#999',
                            symbolSize: 18,
                            symbolShape: 'circle',
                        }
                    ]}
                />
            </div>
            {src && <p className='src-legend p-0'><a href={src} target='_blank' rel="noopener noreferrer">fonte: {src}</a></p>}
        </>
    )
}

export default MyResponsivePie